import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Hero from "./components/Hero";
import Footer from "./components/Footer";
import Section from "./components/Section";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import Udid from "./components/Udid";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/Terms&Condition";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          {/* Home Page */}
          <Route
            path="/"
            element={
              <>
                <Hero />
                <Section />
                <Udid />
                <Reviews />
                <Contact />
                <Footer />
              </>
            }
          />

          {/* Privacy Policy Page */}
          <Route
            path="/privacy-policy"
            element={
              <>
                <PrivacyPolicy />
                <Footer />
              </>
            }
            
          />
            <Route
            path="/terms&conditions"
            element={
              <>
                <TermsAndConditions />
                <Footer />
              </>
            }
            
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
